module.exports = function getResource(label, vars = []) {
    let resources = {
        orderDetails: 'Détails de la commande',
        orderHistory: 'Afficher l’historique complet des commandes',
        orderNumber: 'Numéro de commande',
        pickUpOrderNumber: 'Numéro de la commande à ramasser',
        pickUpOrder: 'Commande à ramasser',
        cancelOrderButton: 'Annuler votre commande',
        showBarcode: 'Montrer le code à barres de la commande à ramasser',
        scan: 'Balayez pour le ramassage',
        show: 'Montrez le code à barres de la commande à ramasser à un conseiller beauté.',
        continueShopping: 'Continuer à magasiner',
        originalReservationTitle: 'Réservation initiale',
        originalReservationText: 'Veuillez consulter votre reçu de magasin ou votre ',
        purchaseHistory: 'historique des achats',
        originalReservationText2: ' pour voir l’achat final de cette commande à ramasser.',
        needToReturn: 'Besoin d’effectuer un retour?',
        returnsText: 'Les retours peuvent être effectués dans tous les magasins avec un reçu valide.',
        seeReturnsPolicy: 'Voir la politique de retour',
        seefaq: 'Voir la FAQ',
        buyItAgainLinkText: 'Page Acheter de nouveau',
        buyItAgainText1: 'Les articles ajoutés en magasin apparaîtront comme une transaction séparée dans votre ',
        buyItAgainText2: ' et auront un reçu de magasin distinct.',
        changedYourMind: 'Vous avez changé d’avis?',
        cancelYourOrder: 'Annulez votre commande',
        statusLabel: 'Statut',
        deliverTo: 'Livrer à',
        deliveryInstructions: 'Instructions de livraison',
        billingInfo: 'Infos de facturation',
        sameDayDelivery: 'Livraison le jour même',
        standardOrder: 'Commande standard',
        selfCancel: 'Vous avez annulé votre commande',
        faqs: 'Voir la FAQ',
        paypalAccount: 'Compte PayPal'
    };

    return resources[label];
};
